import React, { useContext, useState, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { FirebaseContext } from "../admin/context/FirebaseContext";
import Chatbot from "../Components/Chatbot";
import {
  addDoc,
  collection,
  doc,
  updateDoc,
  getDoc,
  setDoc,
  arrayUnion,
  serverTimestamp,
} from "firebase/firestore";

import Header from "../Components/header.component";
import Footer from "../Components/footer.component";
import Spinner from "../Components/spinner.component";

function View() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const { auth, db } = useContext(FirebaseContext);

  const timeStamp = serverTimestamp();
  const visitorRef = collection(db, "visitorList");

  const [idUser, setIdUser] = useState(
    window.localStorage.getItem("userSessionId")
  );

  const addUserVisitPerYear = async () => {
    const dateTime = new Date().toLocaleDateString("fr").replaceAll("/", ".");
    const docRef = doc(db, "visitPerYear", dateTime);
    await getDoc(docRef)
      .then((docSnap) => {
        if (docSnap?.exists()) {
          updateDoc(docRef, {
            users: arrayUnion(JSON.parse(idUser)?.id),
          });
        } else {
          const data = {
            users: [JSON.parse(idUser)?.id],
          };
          setDoc(docRef, data);
        }
      })
      .catch((error) => {
        console.log("error ", error);
      });
  };

  const addUser = async () => {
    await addDoc(visitorRef, {
      visitOn: timeStamp,
    }).then((docRef) => {
      localStorage.setItem(
        "userSessionId",
        JSON.stringify({
          id: docRef._key.path.segments[1],
          visitOn: timeStamp,
        })
      );
      setIdUser(localStorage.getItem("userSessionId"));
      addUserVisitPerYear("userSessionId");
    });
  };
  useEffect(() => {
    const unSubFunc = () => {
      if (idUser === null) {
        addUser();
      } else {
        addUserVisitPerYear();
      }
    };

    return () => {
      unSubFunc();
    };
  }, []);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setTimeout(() => {
          navigate("/admin", {
            replace: true,
          });
        }, 2000);
      } else {
        setLoading(false);
      }
    });

    return () => {
      // Unsubscribe when the component unmounts
      unsubscribe();
    };
  }, []);

  if (loading) {
    return <Spinner />;
  }

  return (
    <>
      <Header />
      <Outlet />
      <Footer />
      <Chatbot />
    </>
  );
}

export default View;
